'use strict';


/**
 * @module iframefactory/Frame
 * @memberof kernel
 * @description Creates and returns a Frame API for dealing with IFrames
 */
//define(function (require) {

	export default function (id, useContainer) {

		var el = document.createElement('iframe');
		var realEl = el;
		el.id = id;
		el.scrolling='no';

		el.allow='autoplay'; //SKATE-1781
		if (useContainer) {
			var container = document.createElement('div');
			el.style.border="0";
			el.style.margin="0";
			el.style.padding="0";
			container.appendChild(el);
			el.style.visibility='inherit';
			el.style.display='inherit';
			el.style.width='100%';
			el.style.height='100%';
			el = container; //Proxy all the stuff in here
		}

		/**
		 * @function show
		 * @description Applies visibility styling 'visible' to DOM element
		 * @instance
		 * @returns void
		 */
		function show() {
			el.style.visibility = 'visible';
			el.style.display = 'block';
		}

		/**
		 * @function hide
		 * @description Applies visibility styling 'hidden' to DOM element
		 * @instance
		 * @returns void
		 */
		function hide() {
			el.style.visibility = 'hidden';
			//el.style.display = 'none';
		}

		function setSrc(source) {
			realEl.src = source;
		}

		/**
		 * @function style
		 * @description Applies CSS styling to DOM element
		 * @param config {object} The CSS Styling data to apply to the DOM element
		 * @instance
		 * @returns void
		 */
		function style(config) {
			setStyles.call(el, config);
		}

		/**
		 * @function setStyles
		 * @description Internal Helper for CSS styling DOM Element.
		 * @private
		 * @param styles {object} The CSS Styling data to apply to the DOM element
		 * @instance
		 * @returns void
		 */
		function setStyles(styles) {
			/* jshint validthis: true */
			Object.keys(styles).forEach(function (style) {
				this.style[style] = styles[style];
			}, this);

			return this;
		}


		return {
			element: el,
			show: show,
			hide: hide,
			style: style,
			setSrc: setSrc
		};
	}
//});